import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, ArrowRightIcon } from 'lucide-react';
import { Product } from '../../types';
import { ProductCard } from '../products/ProductCard';
interface DealsSectionProps {
  products: Product[];
}
export function DealsSection({
  products
}: DealsSectionProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-12 bg-gradient-to-r from-red-600 to-orange-500" aria-labelledby="deals-heading" data-id="element-134" data-mp="1skg16dkzi56p">
      <div className="max-w-7xl mx-auto px-4" data-id="element-135" data-mp="1woe12qi4vk0t">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8" data-id="element-136" data-mp="21n7bub61cwxa">
          <div className="text-white" data-id="element-137" data-mp="14wyciqx0nn7y">
            <h2 id="deals-heading" className="text-2xl md:text-3xl font-bold mb-1" data-id="element-138" data-mp="14xzrv7l2evvh">
              🔥 Deals of the Day
            </h2>
            <p className="text-white/80" data-id="element-139" data-mp="1dx3a69cer78x">
              Limited time offers - Don't miss out!
            </p>
          </div>

          <div className="flex items-center gap-4" data-id="element-140" data-mp="1iocucuf6tidf">
            <div className="flex items-center gap-2 text-white" data-id="element-141" data-mp="1ipwdqtw549jf">
              <ClockIcon className="w-5 h-5" data-id="element-142" data-mp="l7e4hior6j0z" />
              <span className="font-medium" data-id="element-143" data-mp="l6l6b63v11ug">Ends in:</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-144" data-mp="q5pim5m2zfp0">
              <div className="bg-white text-gray-900 px-3 py-2 rounded-lg text-center min-w-[60px]" data-id="element-145" data-mp="1thmrgcg2t07g">
                <span className="text-xl font-bold" data-id="element-146" data-mp="1ok4snevrw1d6">
                  {String(timeLeft.hours).padStart(2, '0')}
                </span>
                <p className="text-xs text-gray-500" data-id="element-147" data-mp="229ygpuzgehlu">Hours</p>
              </div>
              <span className="text-white text-xl font-bold" data-id="element-148" data-mp="1yafwz2jdcckl">:</span>
              <div className="bg-white text-gray-900 px-3 py-2 rounded-lg text-center min-w-[60px]" data-id="element-149" data-mp="1aj22or1nq6wz">
                <span className="text-xl font-bold" data-id="element-150" data-mp="15l0k078589m1">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </span>
                <p className="text-xs text-gray-500" data-id="element-151" data-mp="1jltguylx3gsb">Mins</p>
              </div>
              <span className="text-white text-xl font-bold" data-id="element-152" data-mp="1ek43vdf4wt1l">:</span>
              <div className="bg-white text-gray-900 px-3 py-2 rounded-lg text-center min-w-[60px]" data-id="element-153" data-mp="2uz5g0w6qfb85">
                <span className="text-xl font-bold" data-id="element-154" data-mp="2q0km1ei2pns5">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </span>
                <p className="text-xs text-gray-500" data-id="element-155" data-mp="2ygjq1qgvb6m2">Secs</p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-156" data-mp="32gtugyp0hoyt">
          {products.slice(0, 4).map(product => <ProductCard key={product.id} product={product} data-id="element-157" data-mp="2ti00zh6z9eph" />)}
        </div>

        <div className="mt-8 text-center" data-id="element-158" data-mp="2tkcixucqjp2j">
          <Link to="/products?deals=true" className="inline-flex items-center gap-2 bg-white text-gray-900 px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors" data-id="element-159" data-mp="3h7kjjyz7y9y8">
            View All Deals
            <ArrowRightIcon className="w-4 h-4" data-id="element-160" data-mp="37gzp8nqkvrl4" />
          </Link>
        </div>
      </div>
    </section>;
}